import React from 'react';
import logo from './logo.svg';
import './App.css';
import './assets/bootstrap/css/bootstrap.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/plugins.css';
import './assets/css/helper.css';
import './assets/css/video-popup.css';
import './assets/css/card/css/layout.css';
import './assets/css/card/css/card.css';
import './assets/css/card/style.css';
import './assets/css/quote.css';
import "./assets/css/slick.min.css";
import axios from 'axios';

import {BrowserRouter as Router, Route, Link, Switch} from "react-router-dom";
import Home from './pages/home'
import Blog from './pages/blog'
import Singleblog from './pages/single-blog'
import Dates from './pages/dates'
import Search from './pages/search'
import Signin from './pages/signin'
import Signup from './pages/signup'
import Signout from './pages/signout'
import Forgotpass from './pages/forgotpass';
import WhyCharter from './pages/why-charter';
import Destinations from './pages/destinations';
import Destination from './pages/destination';
import GetQuote from './pages/get-quote';
import Yacht from './pages/yacht';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NoMatch from './pages/no-match';

import Footer from './modules/footer'

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            general_content: {}
        };
    }

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/content.json`)
            .then((response) => {
                this.setState({ general_content: response.data.general });
            })
            .catch();
    }
    render() {
        return (
            <React.Fragment>
                <div className="main-wrapper">
                    <Router>
                    {/* <Header></Header> */}
                        <div>
                            <Switch>
                                <Route exact path="/" component={Home}/>
                                <Route exact path="/blog" component={Blog}/>
                                <Route exact path="/blog/:id" render={(props) => (
                                    <Singleblog key={props.match.params.id} {...props} />)
                                } />
                                <Route exact path="/search" component={Search}/>
                                <Route exact path="/signin" component={Signin}/>
                                <Route exact path="/signup" component={Signup}/>
                                <Route exact path="/signout" component={Signout}/>
                                <Route exact path="/forgotpass" component={Forgotpass}/>
                                <Route exact path="/why-charter" component={WhyCharter}/>
                                <Route exact path="/destinations" render={(props) => (
                                    <Destinations key={props.match.params.id} {...props} />)
                                } />
                                <Route exact path="/destination/:id" render={(props) => (
                                    <Destination key={props.match.params.id} {...props} />)
                                } />
                                <Route exact path="/yacht/:id" render={(props) => (
                                    <Yacht key={props.match.params.id} {...props} />)
                                } />
                                <Route exact path="/yacht/:id/dates" component={Dates}/>
                                <Route exact path="/yacht/:id/get-quote" component={GetQuote}/>
                                <Route exact path="/privacy" component={Privacy} />
                                <Route exact path="/terms" component={Terms} />
                                <Route component={NoMatch} />
                            </Switch>
                        </div>
                        {
                            this.state.general_content && this.state.general_content.fields && <Footer general_content={this.state.general_content}></Footer>
                        }
                    </Router>

                </div>
            </React.Fragment>
        );
    }

}

export default App;
